import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { orderDashboardPath } from 'utils/paths';
import leftNavigationArrow from '../icons/nav-arrow-left.svg';

export const OrderDashboardNavLink = ({ orderDashboardLabel }) => (
  <Link to={orderDashboardPath} className={styles.backToDashboardContainer}>
    <img alt={'left arrow'} src={leftNavigationArrow} />
    <span className={styles.orderDashboardLabel}>{orderDashboardLabel}</span>
  </Link>
);

OrderDashboardNavLink.propTypes = {
  orderDashboardLabel: PropTypes.string.isRequired,
};

export default enhance(OrderDashboardNavLink);
